// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getQuestionSurveys as listQuestionSurveysAPI,
    getQuestionSurvey as getQuestionSurveyAPI,
    addQuestionSurvey as addQuestionSurveyAPI,
    updateQuestionSurvey as updateQuestionSurveyAPI,
    deleteQuestionSurvey as deleteQuestionSurveyAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { questionSurveysApiResponseError, questionSurveysApiResponseSuccess } from './actions';
import { QuestionSurveysActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getQuestionSurvey({ payload: { id } }) {
    try {
        const response = yield call(getQuestionSurveyAPI, id );
        const questionSurveyItem = response.data.data;
        yield put(questionSurveysApiResponseSuccess(QuestionSurveysActionTypes.GET_QUESTION_SURVEY, questionSurveyItem));
    } catch (error) {
        yield put(questionSurveysApiResponseError(QuestionSurveysActionTypes.GET_QUESTION_SURVEY, error));
    }
}

function* addQuestionSurvey({payload:questionSurvey}){
    try{
        const response = yield call(addQuestionSurveyAPI,{...questionSurvey})
        const questionSurveyItem = response.data
        yield put(questionSurveysApiResponseSuccess(QuestionSurveysActionTypes.ADD_QUESTION_SURVEY,questionSurveyItem))
    } catch(error){
        yield put(questionSurveysApiResponseError(QuestionSurveysActionTypes.ADD_QUESTION_SURVEY,error))
    }
}

function* updateQuestionSurvey({payload:questionSurvey}){
    try{
        const response = yield call(updateQuestionSurveyAPI,{...questionSurvey})
        const questionSurveyItem = response.data.data
        yield put(questionSurveysApiResponseSuccess(QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY,questionSurveyItem))
    }catch(error){
        yield put(questionSurveysApiResponseError(QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY,error))
    }
}
function* deleteQuestionSurvey({payload:{id}}){
    try{
        const response = yield call(deleteQuestionSurveyAPI,id)
        const questionSurveyItem = response.data.id
        yield put(questionSurveysApiResponseSuccess(QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY,questionSurveyItem))
    }catch(error){
        yield put(questionSurveysApiResponseError(QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY,error))
    }
}

/**
 * List contactos
 */
function* listQuestionSurveys({payload:params}) {
    try {
        const response = yield call(listQuestionSurveysAPI, { ...params });
        const listaQuestionSurveys = response.data.data;
        yield put(questionSurveysApiResponseSuccess(QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS, listaQuestionSurveys));
    } catch (error) {
        yield put(questionSurveysApiResponseError(QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS, error));
    }
}


export function* watchGetQuestionSurvey(): any {
    yield takeEvery(QuestionSurveysActionTypes.GET_QUESTION_SURVEY, getQuestionSurvey);
}

export function* watchListQuestionSurveys(): any {
    yield takeEvery(QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS, listQuestionSurveys);
}

export function* watchAddQuestionSurvey():any{
    yield takeEvery(QuestionSurveysActionTypes.ADD_QUESTION_SURVEY,addQuestionSurvey)
}
export function* watchUpdateQuestionSurvey():any{
    yield takeEvery(QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY,updateQuestionSurvey)
}
export function* watchDeleteQuestionSurvey():any{
    yield takeEvery(QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY,deleteQuestionSurvey)
}


function* questionSurveysSaga(): any {
    yield all([
        fork(watchGetQuestionSurvey),
        fork(watchListQuestionSurveys),
        fork(watchAddQuestionSurvey),
        fork(watchUpdateQuestionSurvey),
        fork(watchDeleteQuestionSurvey),
    ]);
}

export default questionSurveysSaga;
